<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M53 9H11a2 2 0 00-2 2v42a2 2 0 002 2h42a2 2 0 002-2V11a2 2 0 00-2-2zm-1 43H12V12h40z"/><path d="M32 45.5A13.5 13.5 0 1018.5 32 13.49 13.49 0 0032 45.5zm0-25A11.5 11.5 0 1120.5 32 11.51 11.51 0 0132 20.5z"/><circle cx="27" cy="32" r="2"/><circle cx="37" cy="32" r="2"/></svg>